export default __webpack_public_path__ + "static/media/mftimeline.49b855a2.svg";